import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';

export interface SearchForumFollowTopicPaginationProps {
  className?: string;
  shouldShowLoadMore?: boolean;
  shouldShowLoadLess?: boolean;
  onLoadMore?: () => void;
  onLoadLess?: () => void;
}

const SearchForumFollowTopicPagination: React.FC<SearchForumFollowTopicPaginationProps> =
(props) => {
  const {
    className, shouldShowLoadMore, shouldShowLoadLess, onLoadMore, onLoadLess,
  } = props;
  const { t } = useTranslation();

  const classNames = c('SearchForumThread__Pagination', className);

  return (
    <div className={classNames}>
      {shouldShowLoadMore && onLoadMore && (
        <button
          className="LoadMoreButton"
          onClick={onLoadMore}
          type="button"
        >
          <i className="icon icon-chevron icon-variant-7" />
          {t('pages.forum.follow_forum_topic.load_more')}
        </button>
      )}

      {shouldShowLoadLess && onLoadLess && (
        <button
          className="LoadLessButton"
          onClick={onLoadLess}
          type="button"
        >
          <i className="icon icon-chevron icon-variant-7" />
          {t('pages.forum.follow_forum_topic.show_less')}
        </button>
      )}
    </div>
  );
};

export default SearchForumFollowTopicPagination;
